import { cn } from "@/lib/cn"
import { toneCss } from "../format"
import type { BadgeRowBlock } from "../types"

// Inline status chips. Wrap on every breakpoint (no @container needed —
// flex-wrap is mobile-first by default).
export function BadgeRowBlockView({ block }: { block: BadgeRowBlock }) {
  const badges = Array.isArray(block.badges) ? block.badges : []
  return (
    <div className="flex flex-wrap gap-1.5">
      {badges.map((b, idx) => {
        const css = toneCss(b.tone)
        return (
          <span
            key={`${b.label}-${idx}`}
            className={cn(
              "inline-flex items-center gap-1 rounded-chip border px-2 py-0.5 text-xs font-medium",
              css.text,
              css.bg,
              css.border,
            )}
          >
            <span className={cn("h-1.5 w-1.5 rounded-full", css.dot)} aria-hidden="true" />
            {b.label}
          </span>
        )
      })}
    </div>
  )
}
